import logo from "./logo.png";
import person1 from "./person1.png";
import person2 from "./person2.png";
import person3 from "./person3.png";
import person4 from "./person4.png";
import person5 from "./person5.png";
import person6 from "./person6.png";
import dogButton from "./dogButton.png";
import menu from "./menu.png";
import pencil from "./pencil.png";
import dog1 from "./dog1.png";
import dog2 from "./dog2.png";
import mas from "./+.png";
import helenDNI from "./helenDNI.png";
import helenSquare from "./helenSquare.png";
import dogTired from "./dogTired.png";
import logoPerrito from "./logoPerrito.png";
import logoBlanco from "./logoblanco.png";
import pataCirculo from "./pataCirculo.png";
import instagram from "./instagram.png";
import facebook from "./facebook.png";
import wsp from "./wsp.png";
import c1 from "./c1.png";
import c2 from "./c2.png";
import c3 from "./c3.png";
import c4 from "./c4.png";
import c5 from "./c5.png";
import dogQuestion from "./dog-question.png";

const Imagenes = {
  img1: logo,
  img2: menu,
  img3: person1,
  img4: person2,
  img5: person3,
  img6: person4,
  img7: person5,
  img8: person6,
  img9: dogButton,
  img10: pencil,
  img11: dog1,
  img12: dog2,
  img13: mas,
  img14: helenDNI,
  img15: helenSquare,
  img16: dogTired,
  img17: logoPerrito,
  img18: logoBlanco,
  img19: pataCirculo,
  img20: instagram,
  img21: facebook,
  img22: wsp,
  img23: c1,
  img24: c2,
  img25: c3,
  img26: c4,
  img27: c5,
  img28: dogQuestion,
};

export default Imagenes;
